@if (enabled && fabVisible()) {
  <button
    class="dev-tools-fab"
    [class.recording]="previewService.sessionActive() && !previewService.paused()"
    [class.paused]="previewService.paused()"
    (click)="previewService.togglePanel()"
    type="button"
    aria-label="Toggle Dev Tools"
  >
    <img
      src="assets/sm_clippy.png"
      alt="Dev Tools"
      class="icon"
    />
    @if (previewService.sessionActive() && !previewService.paused()) {
      <span class="recording-dot"></span>
    }
    @if (previewService.paused()) {
      <span class="paused-dot"></span>
    }
    @if (previewService.eventCount() > 0) {
      <span class="badge">{{ previewService.eventCount() > 99 ? '99+' : previewService.eventCount() }}</span>
    }
  </button>
}

@if (enabled && previewService.panelOpen()) {
  <dev-tools-panel></dev-tools-panel>
}
